import { z } from 'zod';

export const EventType = z.enum([
  'game_open',
  'game_start',
  'tutorial_complete',
  'level_start',
  'level_complete',
  'game_over',
  'retry',
  'share',
  'unlock_view',
  'unlock_click',
  'purchase',
  'session_start',
  'session_end',
  'target_spawn',
  'target_click',
  'wrong_click',
]);

export type EventType = z.infer<typeof EventType>;

export const EventSchema = z.object({
  id: z.string().uuid(),
  anonymous_user_id: z.string().min(1),
  game_id: z.string().uuid().nullable(),
  session_id: z.string().min(1),
  event_type: EventType,
  event_data: z.record(z.unknown()).default({}),
  timestamp: z.string().datetime(),
});

export type Event = z.infer<typeof EventSchema>;

export const EventCreateInput = EventSchema.omit({
  id: true,
  timestamp: true,
}).extend({
  event_data: z.record(z.unknown()).default({}),
  timestamp: z.string().datetime().optional(),
  game_id: z.string().uuid().nullable().default(null),
});

export type EventCreateInput = z.infer<typeof EventCreateInput>;

export const EventBatchInput = z.object({
  events: z.array(EventCreateInput).min(1).max(500),
});

export type EventBatchInput = z.infer<typeof EventBatchInput>;
